import clsx from "clsx";
import styles from "./InfoPanel.module.scss";

type IInfoPanel = {
  children: React.ReactNode;
  type: "error" | "info";
  placement?: "top" | "bottom";
};

export const InfoPanel = ({
  children,
  type,
  placement = "bottom",
}: IInfoPanel) => {
  return (
    <section
      className={clsx(
        styles.infoPanel,
        styles[`type-${type}`],
        styles[`placement-${placement}`],
      )}
    >
      {children}
    </section>
  );
};
